module.exports = __webpack_public_path__ + "media/old_images/intro-android-tyresta-aef7e02e.png";